__turbopack_context__.v({
  "blocksBackgroundColor": "megaNav-module-scss-module__XbL8Kq__blocksBackgroundColor",
  "blocksFontColor": "megaNav-module-scss-module__XbL8Kq__blocksFontColor",
  "cdMorphDropdown": "megaNav-module-scss-module__XbL8Kq__cdMorphDropdown",
  "highlight": "megaNav-module-scss-module__XbL8Kq__highlight",
  "icon": "megaNav-module-scss-module__XbL8Kq__icon",
  "mainLink": "megaNav-module-scss-module__XbL8Kq__mainLink",
  "mainNav": "megaNav-module-scss-module__XbL8Kq__mainNav",
  "popupArrow": "megaNav-module-scss-module__XbL8Kq__popupArrow",
  "secondaryNavBackgroundColor": "megaNav-module-scss-module__XbL8Kq__secondaryNavBackgroundColor",
  "themeBackgroundColor": "megaNav-module-scss-module__XbL8Kq__themeBackgroundColor",
  "themeFontColor": "megaNav-module-scss-module__XbL8Kq__themeFontColor",
  "themeFontFamily": "megaNav-module-scss-module__XbL8Kq__themeFontFamily",
});
